import { Text, Button as VuiButton } from '@village/ui';
import { device } from 'citymd/constants/device';
import { rem } from 'polished';
import styled from 'styled-components';

const GlobalContainer = styled.div`
    position: relative;
`;

const Container = styled.div`
    background-color: ${({ theme }) => theme.vui.colors.background.white};
    width: ${rem(482)};
    margin: 0 auto;

    @media ${device.maxTablet} {
        width: auto;
    }
`;

const TopBar = styled.div`
    height: ${rem(8)};
    background-color: ${({ theme }) => theme.vui.colors.icon.default};

    @media ${device.maxTablet} {
        display: none;
    }
`;

const Wrapper = styled.div`
    padding: ${rem(48)};
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
    margin: 0 auto;

    @media ${device.maxTablet} {
        max-width: ${rem(335)};
        padding: ${rem(24)};
    }
`;

const Content = styled.div`
    display: inline-flex;
    flex-direction: column;
    gap: ${rem(12)};
`;

const Title = styled(Text)`
    /* overrides Drupal CMS styling */
    margin-bottom: 0 !important;
`;

const Button = styled(VuiButton)`
    height: ${rem(48)};
    width: ${rem(126)};
`;

export { GlobalContainer, Container, Wrapper, Content, Button, TopBar, Title };
